(() => {
  window.swinger.eventHub.register('click', '.swinger-login__backdrop', (e) => {
    const elem = window.swinger.eventHub.getTarget(e);
    const wrapper = elem.closest('.swinger-login');
    const dialog = wrapper.querySelector('dialog.swinger-login__wrapper');

    if (!dialog) {
      return;
    }

    (
      document.querySelector('#header-button-login')
      || document.querySelector('#swinger-usermenu__toggle')
      || document.body
    ).focus();

    window.swinger.visibility.hide(dialog);
  });
})();
